import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "core-js/modules/es6.regexp.to-string";
import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
// Face Facts 蓝图
import { getLang, getUUid } from "../utils/apiHelper";
import * as constants from "./constants";
import HttpClient from "../http/index";

var CryptoJS = require("crypto-js");

import { clientError } from "@/api/utils/apiHelper";

var TGClient =
/*#__PURE__*/
function () {
  function TGClient() {
    _classCallCheck(this, TGClient);
  }

  _createClass(TGClient, [{
    key: "prettyContent",
    // content需要进行特别的格式化
    value: function prettyContent(content) {
      return _JSON$stringify(content, null, 2);
    }
  }, {
    key: "makeCommonRequest",
    value: function makeCommonRequest() {
      var req = {};
      req.headers = {};
      req.data = {};
      req.baseURL = constants.BASE_URL;
      req.headers["User-Agent"] = constants.UA;
      return req;
    }
  }, {
    key: "signRequest",
    value: function signRequest(req) {
      // 请自行实现签名
      // 算法: HmacSHA256
      // KEY: this.secretKey
      // DATA: req.content
      // signature = 结果的hexString小写
      var signature = CryptoJS.HmacSHA256(req.data.content, constants.SECRET_KEY).toString();
      req.data.signature = signature;
      req.data.sig_kv = "K2184454";
      req.data.cten = "p";
    } // category String 取值范围 ["today", "month", "year", "characteristic"]
    // zodiac   Number 取值范围 0~11 0是白羊座,11是双鱼座
    // queryZodiac(category, zodiac) {
    //     const req = makeCommonRequest();
    //     req.path = "/api/my_horoscope/zodiac/"+category;
    //     const content = {"muid":this.deviceId, "zodiac":zodiac, "client_date":this.clientDate};
    //     req.data.content = prettyContent(content);
    //     signRequest(req);
    // }

  }, {
    key: "queryBaby",
    value: function queryBaby(photo1, photo2) {
      var _this = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var req, content, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  req = _this.makeCommonRequest();
                  req.path = constants.QUERY_BABY;
                  content = {
                    muid: _this.deviceId
                  };
                  req.data.content = _this.prettyContent(content);

                  _this.signRequest(req); // 以表单模式提交 Content-Type: multipart/form-data; boundary=Boundary+0xAbCdEfGbOuNdArY
                  // 请确保你能够设置boundary 0xAbCdEfGbOuNdArY


                  req.headers["Content-Type"] = "multipart/form-data; boundary=Boundary+0xAbCdEfGbOuNdArY";
                  req.fileArray = [{
                    filePath: "file://" + photo1,
                    name: "face_photo1",
                    overlayName: "image.jpg"
                  }, {
                    filePath: "file://" + photo2,
                    name: "face_photo2",
                    overlayName: "image.jpg"
                  }];
                  console.log("queryBaby req:", req);
                  _context.next = 11;
                  return HttpClient.upload(constants.BASE_URL + constants.QUERY_BABY, req);

                case 11:
                  res = _context.sent;
                  resolve(res);
                  _context.next = 19;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](0);
                  reject(_context.t0);
                  clientError("req_query_baby", _context.t0);

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 15]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "clientDate",
    get: function get() {
      var date = new Date();
      var year = ("0000" + date.getFullYear()).slice(-4);
      var month = ("00" + date.getMonth() + 1).slice(-2);
      var day = ("00" + date.getDate()).slice(-2);
      return [year, month, day].join("-");
    }
  }, {
    key: "language",
    get: function get() {
      return getLang();
    }
  }, {
    key: "deviceId",
    get: function get() {
      return getUUid();
    }
  }]);

  return TGClient;
}();

export default new TGClient();